import fileSaver from 'file-saver';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import t from './Pom.type';
import * as PomServices from '../../../../services/pom.services';
import { ERROR_MESSAGE } from '../../../../Components/helper';

export const getAllPom = (params, transactionMsg) => async (dispatch) => {
  try {
    const response = await PomServices.getPom(params);
    if (response.code === 200) {
      await dispatch({
        type: t.GET_ALL_POM,
        payload: response.data,
      });
    } else {
      toasterMsg(transactionMsg(response.message), 'danger');
    }
    return response;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const getAllGradings = (params) => async (dispatch) => {
  try {
    const response = await PomServices.getGrading(params);
    if (response.code === 200) {
      await dispatch({
        type: t.GET_GRADING_LIST,
        payload: response.data,
      });
    } else {
      toasterMsg(response.message, 'danger');
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const getAllGradingsNames = (params) => async (dispatch) => {
  try {
    const response = await PomServices.getGradingName(params);
    if (response.code === 200) {
      await dispatch({
        type: t.GET_GRADING_NAME,
        payload: response.data,
      });
    } else {
      toasterMsg(response.message, 'danger');
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const getuniquePomCode = (params, transactionMsg) => async () => {
  try {
    const response = await PomServices.uniquePomCode(params);
    if (response.data.isUnique) {
      return response.data.isUnique;
    }
    toasterMsg(transactionMsg('POM_LIBRARY.POM_UNIQUE_CODE'), 'danger');
    return response.data.isUnique;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const addPom = (params, transactionMsg) => async () => {
  try {
    const response = await PomServices.addPom(params);
    if (response.code === 200) {
      toasterMsg(transactionMsg(response.message), 'success');
    } else {
      toasterMsg(transactionMsg(response.message), 'danger');
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const updatePom = (params, transactionMsg) => async () => {
  try {
    const response = await PomServices.updatePom(params);
    if (response.code === 200) {
      const msg = transactionMsg('POM.BACKEND_SERVICE.POM_LIBRARY_UPDATED');
      toasterMsg(msg, 'success');
      return true;
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const deletePom = (params, transactionMsg) => async () => {
  try {
    const response = await PomServices.deletePom(params);
    if (response.code === 200) {
      toasterMsg(transactionMsg(response.message), 'success');
    }
    return true;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const multiDeletePom = (params, transactionMsg) => async () => {
  try {
    const response = await PomServices.multiDeletePom(params);
    if (response.code === 200) {
      const msg = transactionMsg('POM.BACKEND_SERVICE.POM_LIBRARY_DELETED');
      toasterMsg(msg, 'success');
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const fetchBrandsForGradingGroup = (params) => async (dispatch) => {
  try {
    const response = await PomServices.fetchGradingBrand(params);
    if (response.code === 200) {
      await dispatch({
        type: t.GET_ALL_BRAND,
        payload: response.data,
      });
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const fetchCategoryOneForGrading = (params) => async (dispatch) => {
  try {
    const response = await PomServices.fetchGradingCategoryOne(params);
    if (response.code === 200) {
      await dispatch({
        type: t.GET_CATEGORY_ONE_DATA,
        payload: response.data,
      });
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const fetchCategoryTwoForGrading = (params) => async (dispatch) => {
  try {
    const response = await PomServices.fetchGradingCategoryOne(params);
    if (response.code === 200) {
      await dispatch({
        type: t.GET_CATEGORY_TWO_DATA,
        payload: response.data,
      });
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const fetchCategoryThreeForGrading = (params) => async (dispatch) => {
  try {
    const response = await PomServices.fetchGradingCategoryOne(params);
    if (response.code === 200) {
      await dispatch({
        type: t.GET_CATEGORY_THREE_DATA,
        payload: response.data,
      });
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const fetchGradingGroupById = (id, params) => async (dispatch) => {
  try {
    const response = await PomServices.fetchGradingById(id, params);
    if (response.code === 200) {
      await dispatch({
        type: t.GET_GRADING_GROUP_DATA_BY_ID,
        payload: response.data,
      });
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const saveGradingGroup = (data, transactionMsg, isReArrange) => async () => {
  try {
    const response = await PomServices.saveGradingGroup(data);
    if (response.code === 200) {
      let msg = '';
      if (isReArrange) {
        msg = transactionMsg('POM.BACKEND_SERVICE.UPDATE_REARRANGE_GRADING');
      } else {
        msg = transactionMsg('POM.BACKEND_SERVICE.SAVE_GRADING_GROUP');
      }
      toasterMsg(msg, 'success');
      return response;
    }
    toasterMsg(transactionMsg(response.data.errMsg), 'danger');
    return response;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

/**
 * Permanently removes the given POM rows from a grading group via a targeted
 * server-side $pull, so the deletion survives without a separate Save click.
 * Returns the API envelope so the caller can roll its table back on failure.
 */
export const deleteGradingGroupPoms = (gradingLibraryId, pomIds, transactionMsg) => async () => {
  try {
    const response = await PomServices.deletePomsFromGradingGroup(gradingLibraryId, pomIds);
    if (response?.code === 200) {
      toasterMsg(transactionMsg('POM.BACKEND_SERVICE.GRADING_GROUP_POMS_DELETED'), 'success');
      return response;
    }
    toasterMsg(response?.data?.errMsg || response?.message || ERROR_MESSAGE, 'danger');
    return response;
  } catch (err) {
    toasterMsg(transactionMsg('POM.BACKEND_SERVICE.GRADING_GROUP_POMS_DELETE_FAILED'), 'danger');
    return undefined;
  }
};

export const fetchUnitOfMeasure = (data) => async (dispatch) => {
  try {
    const res = await PomServices.getUnitOfMeasure(data);
    if (res?.code === 200 && res.data) {
      return await dispatch({
        type: t.FETCH_UNIT_OF_MEASURE,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};
export const eCommSpecAccess = (data) => async (dispatch) => {
  try {
    const res = await PomServices.checkEComSpec(data);
    if (res?.code === 200 && res.data) {
      return await dispatch({
        type: t.SYSTEM_ECOMM_ACCESS,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const fetcheCommSpecData = (data) => async (dispatch) => {
  try {
    const res = await PomServices.fetchEComSpecFromMaster(data);
    if (res?.code === 200 && res.data) {
      return await dispatch({
        type: t.ECOMM_SPEC_DATA,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const checkGradingReference = (id) => async (dispatch) => {
  try {
    const res = await PomServices.checkGradingGroupExistInProduct(id);
    if (res?.code === 200 && res.data) {
      return await dispatch({
        type: t.CHECK_GRADING_REFERENCE,
        payload: res.data.foundReferences,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const uploadPOMXlsxFile = (payload, transactionMsg) => async (dispatch) => {
  try {
    const res = await PomServices.uploadPOMXlsxFileService(payload);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: t.UPDATE_EXCEL_DATA,
        payload: res.data?.PomLibraries?.pomLibraries,
      });
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const fetchUserProfile = () => async (dispatch) => {
  try {
    const res = await PomServices.companyDefaultUnit();
    if (res?.code === 200 && res.data) {
      return await dispatch({
        type: t.DEFAULT_COMPANY_UNIT,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const fetchGradingGroupData = (payload) => async (dispatch) => {
  try {
    const res = await PomServices.gradingGroupData(payload);
    if (res?.code === 200 && res.data) {
      return await dispatch({
        type: t.GRADING_GROUP_LISTING_DATA,
        payload: res.data,
      });
    }
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
};

export const DeleteGradingGroup = (payload, transactionMsg) => async () => {
  try {
    const res = await PomServices.deleteGradingGroup(payload);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg('POM.BACKEND_SERVICE.DELETE_GRADING_GROUP');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
};

export const clearReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_GROUP_REDUCER,
    });
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const duplicateGradingGroup = (payload, transactionMsg) => async (dispatch) => {
  try {
    const res = await PomServices.duplicateGrading(payload);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg('POM.BACKEND_SERVICE.SAVE_GRADING_GROUP');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return res;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
};

export const updateGradingGroupStatus = (payload, transactionMsg) => async (dispatch) => {
  try {
    const res = await PomServices.updateGradingStatus(payload);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg('POM.BACKEND_SERVICE.UPDATE_GRADING_GROUP');
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
};

export const downloadPomLIbrary = (data) => async () => {
  try {
    const res = await PomServices.exportExcelService(data);
    if (res) {
      if (data?.type) {
        fileSaver.saveAs(res, 'Sample Excel POM Library');
      } else {
        fileSaver.saveAs(res, 'POM Library');
      }
    } else if (res?.data && res?.data?.errMsg) {
      toasterMsg(res?.data?.errMsg, 'danger');
    } else if (res?.message) {
      toasterMsg(res?.message, 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const importColLib = (params, trans) => async () => {
  try {
    const response = await PomServices.uploadFile(params);
    if (response && response.code === 200 && response.data && !response?.data?.success) {
      toasterMsg(trans(`BOM_LIBRARY_VIEW.${response.message}`), 'success');
    } else if (response && response.code === 200 && response.data && response?.data?.success) {
      toasterMsg(trans(`BOM_LIBRARY_VIEW.${response.message}`), 'danger');
    } else {
      toasterMsg(trans(response.data.errMsg), 'danger');
    }
    return response;
  } catch (err) {
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const savePomGroup = (data, transactionMsg) => async () => {
  try {
    const response = await PomServices.savePomGroup(data);
    if (response.code === 200) {
      const msg = transactionMsg(`POM_GROUP.${response.message}`);
      toasterMsg(msg, 'success');
      return response;
    }
    toasterMsg(transactionMsg(response.data.errMsg), 'danger');
    return response;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const fetchPomGroupById = (id, obj) => async (dispatch) => {
  try {
    const response = await PomServices.fetchPomGroupById(id, obj);

    if (response.code === 200) {
      await dispatch({
        type: t.POM_GROUP_DATA_BY_ID,
        payload: response.data,
      });
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const fetchPomGroupsData = (params) => async (dispatch) => {
  try {
    const res = await PomServices.fetchPomGroupdata(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.POM_GROUPS_DATA,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    console.error(err.toString());
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const fetchPomGroupsWithLibrary = (params) => async (dispatch) => {
  try {
    const res = await PomServices.fetchPomGroupsWithPomLibrary(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.POM_GROUPS_WITH_LIBRARIES,
        payload: res.data,
      });
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    console.error(err.toString());
    toasterMsg(err, 'danger');
  }
  return Promise.resolve();
};

export const deletePomGroup = (payload, transactionMsg) => async () => {
  try {
    const res = await PomServices.deletePomGroups(payload);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`POM_GROUP.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    console.log(err.toString());
    toasterMsg(err, 'danger');
  }
};

export const fetchCategoryFour = (params) => async (dispatch) => {
  try {
    const response = await PomServices.fetchGradingCategoryOne(params);
    if (response.code === 200) {
      await dispatch({
        type: t.GET_CATEGORY_FOUR_DATA,
        payload: response.data,
      });
    }
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const clearAllRecuderRecords = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_ALL_POM,
      payload: { pomList: [], totalRecords: 0 },
    });
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};

export const downloadGradingSampleFile = (data, translation) => async () => {
  try {
    const res = await PomServices.downloadGradingSampleFile(data);
    if (res) {
      fileSaver.saveAs(res, `Sample ${data?.name} file`);
    } else if (res?.data && res?.data?.errMsg) {
      toasterMsg(translation(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(translation(res?.message), 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const clearGradingGroupReducer = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.CLEAR_GRADING_GROUP_REDUCER,
    });
    return true;
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};
